module.exports = __webpack_public_path__ + "img/background.4048a5bb.png";